import React from 'react';


export default ({ small = false, ...props}) => (
	<span className="loading">
		<span className={`${small ? "spinner-border spinner-border-sm": "spinner-border"}`} role="status" aria-hidden="true">
		</span>
	</span>
);
